import applyConfigListing from './Listing';
import applyConfigTeaser from './Teaser';

const applyConfig = (config) => {
  applyConfigListing(config);
  applyConfigTeaser(config);

  return config;
};

export default applyConfig;
